import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { ArrowRight, Leaf, ShieldCheck, Smartphone, Zap } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const handleAddToCart = () => {
    trackAddToCart();
  };
  return <section id="pricing-cta" className="py-24 bg-cream relative overflow-hidden" data-id="element-91">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-92">
        <div className="absolute -right-20 top-20 w-64 h-64 bg-terracotta/5 rounded-full blur-3xl" data-id="element-93"></div>
        <div className="absolute -left-20 bottom-20 w-64 h-64 bg-sage/10 rounded-full blur-3xl" data-id="element-94"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-16 shadow-2xl shadow-sage/10 border border-sage/10" data-id="element-96">
          <div className="flex justify-center mb-6" data-id="element-97">
            <div className="bg-terracotta/10 p-3 rounded-full" data-id="element-98">
              <Leaf className="h-8 w-8 text-terracotta" data-id="element-99" />
            </div>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-forest mb-6 font-serif leading-tight" data-id="element-100">
            $55 dólares en herramientas prácticas. <br data-id="element-101" />
            <span className="text-terracotta" data-id="element-102">Por $6,39</span>
          </h2>

          <p className="text-xl text-forest/70 max-w-2xl mx-auto mb-8 font-light" data-id="element-103">
            Un solo pago. Acceso en 2 minutos.
          </p>

          <div className="bg-cream/50 p-6 rounded-xl mb-10 border border-sage/10" data-id="element-104">
            <p className="text-lg text-forest font-medium italic font-serif" data-id="element-105">
              "Porque ninguna madre debería enfrentar sola una noche de fiebre,
              tos o dolor de barriga sin las herramientas correctas a la mano."
            </p>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-106">
            <Button variant="primary" size="xl" href="https://pay.hotmart.com/F103634785X" onClick={handleAddToCart} className="w-full md:w-auto min-w-[320px] shadow-xl shadow-terracotta/30 text-lg py-6" data-id="element-107">
              Quiero el Paquete Completo <ArrowRight className="ml-2 h-6 w-6" data-id="element-108" />
            </Button>

            <p className="text-sm font-bold text-terracotta uppercase tracking-wider" data-id="element-109">
              Acceso Inmediato por $6,39 USD
            </p>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-forest/60 font-medium mt-4 pt-6 border-t border-gray-100 w-full" data-id="element-110">
              <div className="flex items-center gap-2" data-id="element-111">
                <Zap className="h-4 w-4 text-sage-dark" data-id="element-112" />
                <span data-id="element-113">Acceso digital inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-114">
                <Smartphone className="h-4 w-4 text-sage-dark" data-id="element-115" />
                <span data-id="element-116">Compatible con celular/tablet</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-117">
                <ShieldCheck className="h-4 w-4 text-sage-dark" data-id="element-118" />
                <span data-id="element-119">Garantía de 7 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}